import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import WhatIsSection from './components/WhatIsSection';
import ComparisonSection from './components/ComparisonSection';
import ReviewSection from './components/ReviewSection';
import SafetySection from './components/SafetySection';
import ArticlesSection from './components/ArticlesSection';
import CtaSection from './components/CtaSection';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://basetaosheet.link';
const faviconUrl = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/0dc5bc4081b05862da3d01553c9c9d93.png';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'BasetaoSheet',
  url: siteUrl,
  description: 'The ultimate resource hub for Basetao Spreadsheet guides, product finds, reviews, shipping information, and shopping tips.',
  inLanguage: 'en',
  publisher: {
    '@type': 'Organization',
    name: 'BasetaoSheet',
    url: siteUrl,
    logo: {
      '@type': 'ImageObject',
      url: faviconUrl,
    },
  },
};

export default function Home() {
  return (
    <>
      <JsonLd data={websiteSchema as unknown as Record<string, unknown>} />
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <CategoryDropdown />
        <CategoryGrid />
        <WhatIsSection />
        <ComparisonSection />
        <ReviewSection />
        <SafetySection />
        <ArticlesSection />
        <CtaSection />
      </main>
      <Footer />
    </>
  );
}